import React, {useContext, useState} from "react";
import {Image, Table} from "react-bootstrap";
import {WizardContext} from "../Wizard";
import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";

export function WizardFormReference({ data }) {
    const { imgList } = useContext(WizardContext);
    const [isOpen, setIsOpen] = useState(false);
    const [photoIndex, setPhotoIndex] = useState(0);
    return (
        <Table striped bordered>
            <thead className="thead-dark">
            <tr>
                <th>세부 디자인</th>
                <th>내용</th>
            </tr>
            </thead>
            <tbody>
            <tr>
                <td>
                    디자인 설명
                </td>
                <td>
                    <div className="d-flex align-items-center py-lg-0 py-2">
                        <div className="d-flex flex-column text-right">
                            <span
                                className="text-dark-75 font-weight-bolder text-hover-primary font-size-lg">
                                {data && data[0]?.contents}
                            </span>
                            <span className="text-muted font-weight-bolder font-size-sm">
                            </span>
                        </div>
                    </div>
                </td>
            </tr>
            {
                imgList && imgList.map((item, i) =>
                    <tr key={"design-" + i}>
                        <td>
                            참고 이미지
                        </td>
                        <td>
                            <Image alt={""} src={item} rounded width={171} height={180} onClick={() => {
                                setIsOpen(true)
                                setPhotoIndex(i)
                            } }/>
                            {isOpen &&
                                <Lightbox mainSrc={imgList[photoIndex]}
                                          nextSrc={imgList[(photoIndex + 1)]}
                                          prevSrc={imgList[(photoIndex - 1)]}
                                          onCloseRequest={() => setIsOpen(false)}
                                          onMovePrevRequest={() => setPhotoIndex(photoIndex - 1) }
                                          onMoveNextRequest={() => setPhotoIndex(photoIndex + 1) }
                                          clickOutsideToClose={false}
                                />
                            }
                        </td>
                    </tr>
                )
            }
            </tbody>
        </Table>
    )
}